"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresetsUtils = void 0;
var PresetsUtils = /** @class */ (function () {
    function PresetsUtils() {
    }
    PresetsUtils.groupPresetAreasByType = function (options) {
        var presetAreasMapping = options.presetAreasMapping, acceptableTypes = options.acceptableTypes;
        var result = {};
        // @ts-ignore
        acceptableTypes.forEach(function (presetType) { return (result[presetType] = {}); });
        Object.keys(presetAreasMapping).forEach(function (presetName) {
            Object.keys(presetAreasMapping[presetName]).forEach(function (presetType) {
                if (acceptableTypes.indexOf(presetType) === -1) {
                }
                else {
                    // @ts-ignore
                    result[presetType][presetName] =
                        presetAreasMapping[presetName][presetType];
                }
            });
        });
        return result;
    };
    return PresetsUtils;
}());
exports.PresetsUtils = PresetsUtils;
//# sourceMappingURL=presets-utils.js.map